import { manyOf, selectedRowFilter } from '@/components/Internal/DataTable'

export const financeListFilters = {
  /** The open contract. Named, it fills the tab in place of the overview. */
  contract: selectedRowFilter(),

  /** The unfolded invoices of that contract. */
  invoices: manyOf(selectedRowFilter()),
}
